import { ref, computed } from "vue";
import { defineStore } from "pinia";
import { useAppStore } from "#imports";

export const usePageStore = defineStore('pageStore', () => {
    const { txt } = storeToRefs(useAppStore());

    const _isPending = ref<boolean>(false);
    const changesExist = ref<boolean>(false);
    const isForceNav = ref<boolean>(false);
    const isWarningShown = ref<boolean>(false);
    const tempNavTo = ref<Object | null>(null);
    const prevRoute = ref<string>('');
    const pages = computed(() => [
        {
            title: txt.value.pages.home.nav,
            id: 1,
            icon: 'mdi-account-circle-outline',
            to: '/'
        },
        {
           title: txt.value.pages.development.nav,
           id: 2,
           icon: 'mdi-code-braces-box',
           to: '/dev'
        },
        {
           title: txt.value.pages.art.nav,
           id: 3,
           icon: 'mdi-brush',
           to: '/art'
        },
        {
           title: txt.value.pages.contact.nav,
           id: 4,
           icon: 'mdi-frequently-asked-questions',
           to: '/contact'
        }
    ]);

    const isPending = computed(() => { return _isPending.value });

    function $reset(): void {
        changesExist.value = false;
        isForceNav.value = false;
        isWarningShown.value = false;
        tempNavTo.value = null;
        _isPending.value = false;
    }

    return {
        pages, changesExist, isForceNav, isWarningShown, tempNavTo, isPending, prevRoute,
        $reset
    }
});

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(usePageStore, import.meta.hot))
}